// /* eslint-disable no-unused-vars */
// import React, { useState } from "react";
// import * as styles from "./ProjectStatus.module.css";
// import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";
// import statusImage1 from "../../../images/on-going-projects/enchanted/project-status/august-2025/1.jpg";
// import statusImage2 from "../../../images/on-going-projects/enchanted/project-status/august-2025/2.jpg";
// import statusImage3 from "../../../images/on-going-projects/enchanted/project-status/august-2025/3.jpg";
// import statusImage4 from "../../../images/on-going-projects/enchanted/project-status/august-2025/4.jpg";

// import statusImage5 from "../../../images/on-going-projects/enchanted/project-status/september-2025/1.jpg";
// import statusImage6 from "../../../images/on-going-projects/enchanted/project-status/september-2025/2.jpg";
// import statusImage7 from "../../../images/on-going-projects/enchanted/project-status/september-2025/3.jpg";
// import statusImage8 from "../../../images/on-going-projects/enchanted/project-status/september-2025/4.jpg";
// import statusImage9 from "../../../images/on-going-projects/enchanted/project-status/september-2025/5.jpg";
// import statusImage10 from "../../../images/on-going-projects/enchanted/project-status/september-2025/6.jpg";
// import statusImage11 from "../../../images/on-going-projects/enchanted/project-status/september-2025/7.jpg";
// import statusImage12 from "../../../images/on-going-projects/enchanted/project-status/september-2025/8.jpg";

// import statusImage13 from "../../../images/on-going-projects/enchanted/project-status/october-2025/1.jpeg";
// import statusImage14 from "../../../images/on-going-projects/enchanted/project-status/october-2025/2.jpeg";
// import statusImage15 from "../../../images/on-going-projects/enchanted/project-status/october-2025/3.jpeg";
// import statusImage16 from "../../../images/on-going-projects/enchanted/project-status/october-2025/4.jpeg";
// import statusImage17 from "../../../images/on-going-projects/enchanted/project-status/october-2025/5.jpeg";
// import statusImage18 from "../../../images/on-going-projects/enchanted/project-status/october-2025/6.jpeg";
// import statusImage19 from "../../../images/on-going-projects/enchanted/project-status/october-2025/7.jpeg";

//  import statusImage20 from "../../../images/on-going-projects/enchanted/project-status/november-2025/1.jpg";
//  import statusImage21 from "../../../images/on-going-projects/enchanted/project-status/november-2025/2.jpg";
//  import statusImage22 from "../../../images/on-going-projects/enchanted/project-status/november-2025/3.jpg";
//  import statusImage23 from "../../../images/on-going-projects/enchanted/project-status/november-2025/4.jpg";
//  import statusImage24 from "../../../images/on-going-projects/enchanted/project-status/november-2025/5.jpg";
//  import statusImage25 from "../../../images/on-going-projects/enchanted/project-status/november-2025/6.jpg";
//  import statusImage26 from "../../../images/on-going-projects/enchanted/project-status/november-2025/7.jpg";
//  import statusImage27 from "../../../images/on-going-projects/enchanted/project-status/november-2025/8.jpg";
//  import statusImage28 from "../../../images/on-going-projects/enchanted/project-status/november-2025/9.jpg";
//  import statusImage29 from "../../../images/on-going-projects/enchanted/project-status/november-2025/10.jpg";

//  import statusImage30 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (3).jpeg";
//  import statusImage31 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (4).jpeg";
//  import statusImage32 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (5).jpeg";
//  import statusImage33 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (6).jpeg";
 

//  import statusImage34 from "../../../images/on-going-projects/enchanted/project-status/january-2026/1.jpeg";
//  import statusImage35 from "../../../images/on-going-projects/enchanted/project-status/january-2026/2.jpeg";
//  import statusImage36 from "../../../images/on-going-projects/enchanted/project-status/january-2026/3.jpeg";
//  import statusImage37 from "../../../images/on-going-projects/enchanted/project-status/january-2026/4.jpeg";
//  import statusImage38 from "../../../images/on-going-projects/enchanted/project-status/january-2026/5.jpeg";
//  import statusImage39 from "../../../images/on-going-projects/enchanted/project-status/january-2026/6.jpeg";
//  import statusImage40 from "../../../images/on-going-projects/enchanted/project-status/january-2026/7.jpeg";
//  import statusImage41 from "../../../images/on-going-projects/enchanted/project-status/january-2026/8.jpg";
//  import statusImage42 from "../../../images/on-going-projects/enchanted/project-status/january-2026/9.jpeg";
//  import statusImage43 from "../../../images/on-going-projects/enchanted/project-status/january-2026/10.jpeg";
//  import statusImage44 from  "../../../images/on-going-projects/enchanted/project-status/january-2026/11.jpeg";
//  import statusImage45 from "../../../images/on-going-projects/enchanted/project-status/january-2026/12.jpeg";
//  import statusImage46 from "../../../images/on-going-projects/enchanted/project-status/january-2026/13.jpeg";
//  import statusImage47 from "../../../images/on-going-projects/enchanted/project-status/january-2026/14.jpeg";
//  import statusImage48 from "../../../images/on-going-projects/enchanted/project-status/january-2026/15.jpeg";

// import ImageModal from "./ImageModal";

// function ProjectStatus() {
//   const [activeMonth, setActiveMonth] = useState(0);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const months = [];

//   const projectUpdates = [
//     {
//       title: "August 2025",
//       images: [
//         statusImage1,
//         statusImage2,
//         statusImage3,
//         statusImage4,
//       ],
//     },
//     {
//       title: "September 2025",
//       images: [
//         statusImage5,
//         statusImage6,
//         statusImage7,
//         statusImage8,
//         statusImage9,
//         statusImage10,
//         statusImage11,
//         statusImage12,
//       ],
//     },
//     {
//       title: "October 2025",
//       images: [
//         statusImage13,
//         statusImage14,
//         statusImage15,
//         statusImage16,
//         statusImage17,
//         statusImage18,
//         statusImage19,
//       ],
//     },
//     {
//       title: "November 2025",
//       images: [
//         statusImage20,
//         statusImage21,
//         statusImage22,
//         statusImage23,
//         statusImage24,
//         statusImage25,
//         statusImage26,
//         statusImage27,
//         statusImage28,
//         statusImage29,
        
//       ],
//     },
//     {
//       title: "December 2025",
//       images: [
     
//         statusImage30,
//         statusImage31,
//         statusImage32,
//         statusImage33,
       
//       ],
//     },
//     {
//       title: "January 2026",
//       images: [
//         statusImage34,
//         statusImage35,
//         statusImage36,
//         statusImage37,
//         statusImage38,
//         statusImage39,
//         statusImage40,
//         statusImage41,
//         statusImage42,
//         statusImage43,
//         statusImage44,
//         statusImage45,
//         statusImage46,
//         statusImage47,
//         statusImage48
//       ]
//     }
//   ];
//   const sortedProjectUpdates = [...projectUpdates]?.reverse();

//   return (
//     <div className={styles.projectStatus} id="project-status">
//       <div className={styles.projectStatusContent}>
//         <h1>
//           <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
//           Project Status
//         </h1>
//         <div className={styles.timelineGrid}>
//           {sortedProjectUpdates?.map((month, index) => (
//             <button
//               key={index}
//               className={`${styles.monthButton} ${
//                 index === activeMonth ? styles.active : ""
//               }`}
//               onClick={() => setActiveMonth(index)}
//             >
//               {month.title}
//             </button>
//           ))}
//         </div>
//         <div className={styles.statusCards}>
//           {sortedProjectUpdates?.[activeMonth]?.images?.map((update, index) => (
//             <div
//               className={styles.statusCard}
//               key={index}
//               onClick={() => {
//                 setSelectedImage(index + 1);
//                 setIsModalOpen(true);
//               }}
//             >
//               {/* <img loading="lazy"  fluid={update.childImageSharp.fluid} alt="status-image" /> */}
//               <img loading="lazy"  src={update} alt="status-image" />
//             </div>
//           ))}
//         </div>
//       </div>

//       {isModalOpen ? (
//         <ImageModal
//           imagesArray={sortedProjectUpdates?.[activeMonth]?.images}
//           selectedImage={selectedImage}
//           setSelectedImage={setSelectedImage}
//           showModal={isModalOpen}
//           setShowModal={setIsModalOpen}
//         />
//       ) : null}
//     </div>
//   );
// }

// export default ProjectStatus;

/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import * as styles from "./ProjectStatus.module.css";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";

// August
import statusImage1 from "../../../images/on-going-projects/enchanted/project-status/august-2025/1.jpg";
import statusImage2 from "../../../images/on-going-projects/enchanted/project-status/august-2025/2.jpg";
import statusImage3 from "../../../images/on-going-projects/enchanted/project-status/august-2025/3.jpg";
import statusImage4 from "../../../images/on-going-projects/enchanted/project-status/august-2025/4.jpg";

// September
import statusImage5 from "../../../images/on-going-projects/enchanted/project-status/september-2025/1.jpg";
import statusImage6 from "../../../images/on-going-projects/enchanted/project-status/september-2025/2.jpg";
import statusImage7 from "../../../images/on-going-projects/enchanted/project-status/september-2025/3.jpg";
import statusImage8 from "../../../images/on-going-projects/enchanted/project-status/september-2025/4.jpg";
import statusImage9 from "../../../images/on-going-projects/enchanted/project-status/september-2025/5.jpg";
import statusImage10 from "../../../images/on-going-projects/enchanted/project-status/september-2025/6.jpg";
import statusImage11 from "../../../images/on-going-projects/enchanted/project-status/september-2025/7.jpg";
import statusImage12 from "../../../images/on-going-projects/enchanted/project-status/september-2025/8.jpg";

// October
import statusImage13 from "../../../images/on-going-projects/enchanted/project-status/october-2025/1.jpeg";
import statusImage14 from "../../../images/on-going-projects/enchanted/project-status/october-2025/2.jpeg";
import statusImage15 from "../../../images/on-going-projects/enchanted/project-status/october-2025/3.jpeg";
import statusImage16 from "../../../images/on-going-projects/enchanted/project-status/october-2025/4.jpeg";
import statusImage17 from "../../../images/on-going-projects/enchanted/project-status/october-2025/5.jpeg";
import statusImage18 from "../../../images/on-going-projects/enchanted/project-status/october-2025/6.jpeg";
import statusImage19 from "../../../images/on-going-projects/enchanted/project-status/october-2025/7.jpeg";

// November
import statusImage20 from "../../../images/on-going-projects/enchanted/project-status/november-2025/1.jpg";
import statusImage21 from "../../../images/on-going-projects/enchanted/project-status/november-2025/2.jpg";
import statusImage22 from "../../../images/on-going-projects/enchanted/project-status/november-2025/3.jpg";
import statusImage23 from "../../../images/on-going-projects/enchanted/project-status/november-2025/4.jpg";
import statusImage24 from "../../../images/on-going-projects/enchanted/project-status/november-2025/5.jpg";
import statusImage25 from "../../../images/on-going-projects/enchanted/project-status/november-2025/6.jpg";
import statusImage26 from "../../../images/on-going-projects/enchanted/project-status/november-2025/7.jpg";
import statusImage27 from "../../../images/on-going-projects/enchanted/project-status/november-2025/8.jpg";
import statusImage28 from "../../../images/on-going-projects/enchanted/project-status/november-2025/9.jpg";
import statusImage29 from "../../../images/on-going-projects/enchanted/project-status/november-2025/10.jpg";

// December
import statusImage30 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (3).jpeg";
import statusImage31 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (4).jpeg";
import statusImage32 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (5).jpeg";
import statusImage33 from "../../../images/on-going-projects/enchanted/project-status/december-2025/Enchante (6).jpeg";

// January
import statusImage34 from "../../../images/on-going-projects/enchanted/project-status/january-2026/1.jpeg";
import statusImage35 from "../../../images/on-going-projects/enchanted/project-status/january-2026/2.jpeg";
import statusImage36 from "../../../images/on-going-projects/enchanted/project-status/january-2026/3.jpeg";
import statusImage37 from "../../../images/on-going-projects/enchanted/project-status/january-2026/4.jpeg";
import statusImage38 from "../../../images/on-going-projects/enchanted/project-status/january-2026/5.jpeg";
import statusImage39 from "../../../images/on-going-projects/enchanted/project-status/january-2026/6.jpeg";
import statusImage40 from "../../../images/on-going-projects/enchanted/project-status/january-2026/7.jpeg";
import statusImage41 from "../../../images/on-going-projects/enchanted/project-status/january-2026/8.jpg";
import statusImage42 from "../../../images/on-going-projects/enchanted/project-status/january-2026/9.jpeg";
import statusImage43 from "../../../images/on-going-projects/enchanted/project-status/january-2026/10.jpeg";
import statusImage44 from "../../../images/on-going-projects/enchanted/project-status/january-2026/11.jpeg";
import statusImage45 from "../../../images/on-going-projects/enchanted/project-status/january-2026/12.jpeg";
import statusImage46 from "../../../images/on-going-projects/enchanted/project-status/january-2026/13.jpeg";
import statusImage47 from "../../../images/on-going-projects/enchanted/project-status/january-2026/14.jpeg";
import statusImage48 from "../../../images/on-going-projects/enchanted/project-status/january-2026/15.jpeg";

// February
import statusImageFeb1 from "../../../images/on-going-projects/enchanted/project-status/February-2026/1.jpg";
import statusImageFeb2 from "../../../images/on-going-projects/enchanted/project-status/February-2026/2.jpg";
import statusImageFeb3 from "../../../images/on-going-projects/enchanted/project-status/February-2026/3.jpg";
import statusImageFeb4 from "../../../images/on-going-projects/enchanted/project-status/February-2026/4.jpg";
import statusImageFeb5 from "../../../images/on-going-projects/enchanted/project-status/February-2026/5.jpg";
import statusImageFeb6 from "../../../images/on-going-projects/enchanted/project-status/February-2026/6.jpg";
import statusImageFeb7 from "../../../images/on-going-projects/enchanted/project-status/February-2026/7.jpg";
import statusImageFeb8 from "../../../images/on-going-projects/enchanted/project-status/February-2026/8.jpg";
import statusImageFeb9 from "../../../images/on-going-projects/enchanted/project-status/February-2026/9.jpg";

// March
import statusImageMar1 from "../../../images/on-going-projects/enchanted/project-status/March-2026/1.jpeg";
import statusImageMar2 from "../../../images/on-going-projects/enchanted/project-status/March-2026/2.jpeg";
import statusImageMar3 from "../../../images/on-going-projects/enchanted/project-status/March-2026/3.jpeg";
import statusImageMar4 from "../../../images/on-going-projects/enchanted/project-status/March-2026/4.jpeg";
import statusImageMar5 from "../../../images/on-going-projects/enchanted/project-status/March-2026/5.jpeg";
import statusImageMar6 from "../../../images/on-going-projects/enchanted/project-status/March-2026/6.jpeg";
import statusImageMar7 from "../../../images/on-going-projects/enchanted/project-status/March-2026/7.jpeg";
import statusImageMar8 from "../../../images/on-going-projects/enchanted/project-status/March-2026/8.jpeg";
import statusImageMar9 from "../../../images/on-going-projects/enchanted/project-status/March-2026/9.jpeg";
import statusImageMar10 from "../../../images/on-going-projects/enchanted/project-status/March-2026/10.jpeg";
import statusImageMar11 from "../../../images/on-going-projects/enchanted/project-status/March-2026/11.jpeg";
import statusImageMar12 from "../../../images/on-going-projects/enchanted/project-status/March-2026/12.jpeg";

// April
import statusImageApr1 from "../../../images/on-going-projects/enchanted/project-status/April-2026/1.jpeg";
import statusImageApr2 from "../../../images/on-going-projects/enchanted/project-status/April-2026/2.jpeg";
import statusImageApr3 from "../../../images/on-going-projects/enchanted/project-status/April-2026/3.jpeg";
import statusImageApr4 from "../../../images/on-going-projects/enchanted/project-status/April-2026/4.jpeg";
import statusImageApr5 from "../../../images/on-going-projects/enchanted/project-status/April-2026/5.jpeg";
import statusImageApr6 from "../../../images/on-going-projects/enchanted/project-status/April-2026/6.jpeg";
import statusImageApr7 from "../../../images/on-going-projects/enchanted/project-status/April-2026/7.jpeg";
import statusImageApr8 from "../../../images/on-going-projects/enchanted/project-status/April-2026/8.jpeg";
import statusImageApr9 from "../../../images/on-going-projects/enchanted/project-status/April-2026/9.jpeg";

// May
import statusImageMay1 from "../../../images/on-going-projects/enchanted/project-status/May-2026/1.jpeg";
import statusImageMay2 from "../../../images/on-going-projects/enchanted/project-status/May-2026/2.jpeg";
import statusImageMay3 from "../../../images/on-going-projects/enchanted/project-status/May-2026/3.jpeg";
import statusImageMay4 from "../../../images/on-going-projects/enchanted/project-status/May-2026/4.jpeg";
import statusImageMay5 from "../../../images/on-going-projects/enchanted/project-status/May-2026/5.jpeg";
import statusImageMay6 from "../../../images/on-going-projects/enchanted/project-status/May-2026/6.jpeg";
import statusImageMay7 from "../../../images/on-going-projects/enchanted/project-status/May-2026/7.jpeg";
import statusImageMay8 from "../../../images/on-going-projects/enchanted/project-status/May-2026/8.jpeg";
import statusImageMay9 from "../../../images/on-going-projects/enchanted/project-status/May-2026/9.jpeg";
import statusImageMay10 from "../../../images/on-going-projects/enchanted/project-status/May-2026/10.jpeg";
import statusImageMay11 from "../../../images/on-going-projects/enchanted/project-status/May-2026/11.jpeg";
import statusImageMay12 from "../../../images/on-going-projects/enchanted/project-status/May-2026/12.jpeg";
import statusImageMay13 from "../../../images/on-going-projects/enchanted/project-status/May-2026/13.jpeg";

// June
import statusImageJun1 from "../../../images/on-going-projects/enchanted/project-status/June-2026/1.jpeg";
import statusImageJun2 from "../../../images/on-going-projects/enchanted/project-status/June-2026/2.jpeg";
import statusImageJun3 from "../../../images/on-going-projects/enchanted/project-status/June-2026/3.jpeg";
import statusImageJun4 from "../../../images/on-going-projects/enchanted/project-status/June-2026/4.jpeg";
import statusImageJun5 from "../../../images/on-going-projects/enchanted/project-status/June-2026/5.jpeg";
import statusImageJun6 from "../../../images/on-going-projects/enchanted/project-status/June-2026/6.jpeg";
import statusImageJun7 from "../../../images/on-going-projects/enchanted/project-status/June-2026/7.jpeg";
import statusImageJun8 from "../../../images/on-going-projects/enchanted/project-status/June-2026/8.jpeg";
import statusImageJun9 from "../../../images/on-going-projects/enchanted/project-status/June-2026/9.jpeg";
import statusImageJun10 from "../../../images/on-going-projects/enchanted/project-status/June-2026/10.jpeg";
import statusImageJun11 from "../../../images/on-going-projects/enchanted/project-status/June-2026/11.jpeg";
import statusImageJun12 from "../../../images/on-going-projects/enchanted/project-status/June-2026/12.jpeg";

// July
import statusImageJul1 from "../../../images/on-going-projects/enchanted/project-status/July-2026/1.jpeg";
import statusImageJul2 from "../../../images/on-going-projects/enchanted/project-status/July-2026/2.jpeg";
import statusImageJul3 from "../../../images/on-going-projects/enchanted/project-status/July-2026/3.jpeg";
import statusImageJul4 from "../../../images/on-going-projects/enchanted/project-status/July-2026/4.jpeg";
import statusImageJul5 from "../../../images/on-going-projects/enchanted/project-status/July-2026/5.jpeg";
import statusImageJul6 from "../../../images/on-going-projects/enchanted/project-status/July-2026/6.jpeg";
import statusImageJul7 from "../../../images/on-going-projects/enchanted/project-status/July-2026/7.jpeg";
import statusImageJul8 from "../../../images/on-going-projects/enchanted/project-status/July-2026/8.jpeg";
import statusImageJul9 from "../../../images/on-going-projects/enchanted/project-status/July-2026/9.jpeg";
import statusImageJul10 from "../../../images/on-going-projects/enchanted/project-status/July-2026/10.jpeg";
import statusImageJul11 from "../../../images/on-going-projects/enchanted/project-status/July-2026/11.jpeg";
import statusImageJul12 from "../../../images/on-going-projects/enchanted/project-status/July-2026/12.jpeg";
import statusImageJul13 from "../../../images/on-going-projects/enchanted/project-status/July-2026/13.jpeg";
import statusImageJul14 from "../../../images/on-going-projects/enchanted/project-status/July-2026/14.jpeg";
import statusImageJul15 from "../../../images/on-going-projects/enchanted/project-status/July-2026/15.jpeg";
import statusImageJul16 from "../../../images/on-going-projects/enchanted/project-status/July-2026/16.jpeg";
import statusImageJul17 from "../../../images/on-going-projects/enchanted/project-status/July-2026/17.jpeg";
import statusImageJul18 from "../../../images/on-going-projects/enchanted/project-status/July-2026/18.jpeg";
import statusImageJul19 from "../../../images/on-going-projects/enchanted/project-status/July-2026/19.jpeg";
import statusImageJul20 from "../../../images/on-going-projects/enchanted/project-status/July-2026/20.jpeg";

// August
import statusImageAug1 from "../../../images/on-going-projects/enchanted/project-status/august-2026/1.jpeg";
import statusImageAug2 from "../../../images/on-going-projects/enchanted/project-status/august-2026/2.jpeg";
import statusImageAug3 from "../../../images/on-going-projects/enchanted/project-status/august-2026/3.jpeg";
import statusImageAug4 from "../../../images/on-going-projects/enchanted/project-status/august-2026/4.jpeg";
import statusImageAug5 from "../../../images/on-going-projects/enchanted/project-status/august-2026/5.jpeg";
import statusImageAug6 from "../../../images/on-going-projects/enchanted/project-status/august-2026/6.jpeg";
import statusImageAug7 from "../../../images/on-going-projects/enchanted/project-status/august-2026/7.jpeg";
import statusImageAug8 from "../../../images/on-going-projects/enchanted/project-status/august-2026/8.jpeg";

import ImageModal from "./ImageModal";

const projectUpdates = [
  {
    title: "August 2025",
    images: [statusImage1, statusImage2, statusImage3, statusImage4],
  },
  {
    title: "September 2025",
    images: [statusImage5, statusImage6, statusImage7, statusImage8, statusImage9, statusImage10, statusImage11, statusImage12],
  },
  {
    title: "October 2025",
    images: [statusImage13, statusImage14, statusImage15, statusImage16, statusImage17, statusImage18, statusImage19],
  },
  {
    title: "November 2025",
    images: [statusImage20, statusImage21, statusImage22, statusImage23, statusImage24, statusImage25, statusImage26, statusImage27, statusImage28, statusImage29],
  },
  {
    title: "December 2025",
    images: [statusImage30, statusImage31, statusImage32, statusImage33],
  },
  {
    title: "January 2026",
    images: [statusImage34, statusImage35, statusImage36, statusImage37, statusImage38, statusImage39, statusImage40, statusImage41, statusImage42, statusImage43, statusImage44, statusImage45, statusImage46, statusImage47, statusImage48],
  },
  {
    title: "February 2026",
    images: [statusImageFeb1, statusImageFeb2, statusImageFeb3, statusImageFeb4, statusImageFeb5, statusImageFeb6, statusImageFeb7, statusImageFeb8, statusImageFeb9],
  },
  {
    title: "March 2026",
    images: [statusImageMar1, statusImageMar2, statusImageMar3, statusImageMar4, statusImageMar5, statusImageMar6, statusImageMar7, statusImageMar8, statusImageMar9, statusImageMar10, statusImageMar11, statusImageMar12],
  },
  {
    title: "April 2026",
    images: [statusImageApr1, statusImageApr2, statusImageApr3, statusImageApr4, statusImageApr5, statusImageApr6, statusImageApr7, statusImageApr8, statusImageApr9],
  },
  {
    title: "May 2026",
    images: [statusImageMay1, statusImageMay2, statusImageMay3, statusImageMay4, statusImageMay5, statusImageMay6, statusImageMay7, statusImageMay8, statusImageMay9, statusImageMay10, statusImageMay11, statusImageMay12, statusImageMay13],
  },
  {
    title: "June 2026",
    images: [statusImageJun1, statusImageJun2, statusImageJun3, statusImageJun4, statusImageJun5, statusImageJun6, statusImageJun7, statusImageJun8, statusImageJun9, statusImageJun10, statusImageJun11, statusImageJun12],
  },
  {
    title: "July 2026",
    images: [statusImageJul1, statusImageJul2, statusImageJul3, statusImageJul4, statusImageJul5, statusImageJul6, statusImageJul7, statusImageJul8, statusImageJul9, statusImageJul10, statusImageJul11, statusImageJul12, statusImageJul13, statusImageJul14, statusImageJul15, statusImageJul16, statusImageJul17, statusImageJul18, statusImageJul19, statusImageJul20],
  },
  {
    title: "August 2026",
    images: [statusImageAug1, statusImageAug2, statusImageAug3, statusImageAug4, statusImageAug5, statusImageAug6, statusImageAug7, statusImageAug8],
  },
];

// Newest first (April → August)
const sortedProjectUpdates = [...projectUpdates].reverse();

function ProjectStatus() {
  const [activeMonth, setActiveMonth] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className={styles.projectStatus} id="project-status">
      <div className={styles.projectStatusContent}>
        <h1>
          <img loading="lazy" src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
          Project Status
        </h1>
        <div className={styles.timelineGrid}>
          {sortedProjectUpdates.map((month, index) => (
            <button
              key={index}
              className={`${styles.monthButton} ${index === activeMonth ? styles.active : ""}`}
              onClick={() => setActiveMonth(index)}
            >
              {month.title}
            </button>
          ))}
        </div>
        <div className={styles.statusCards}>
          {sortedProjectUpdates[activeMonth].images.map((update, index) => (
            <div
              className={styles.statusCard}
              key={index}
              onClick={() => {
                setSelectedImage(index + 1);
                setIsModalOpen(true);
              }}
            >
              <img loading="lazy" src={update} alt="status-image" />
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <ImageModal
          imagesArray={sortedProjectUpdates[activeMonth].images}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showModal={isModalOpen}
          setShowModal={setIsModalOpen}
        />
      )}
    </div>
  );
}

export default ProjectStatus